import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { DoLogin } from '../../components/MojaveLib';

function Login({changeLanguage}) {

    const {t, i18n} = useTranslation('translation');

    const [formItems, setFormItems] = useState({'email':'', 'password':''});

    useEffect(() => {
        changeLanguage('en');
    }, [i18n]);

    const handleChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        setFormItems(prevProps => ({...prevProps, [name]:value}));
    }

    const submitLogin = (e) => {
        e.preventDefault();

        let formData = {...formItems};
            formData.email = formData.email.trim();

        DoLogin(formData);
    }

    return (
        <div id="body" className="theme-cyan">
            <div className="authentication">
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                            <div className="company_detail">
                                <h4 className="logo"><img className="mr-2" src="assets/images/logo.svg" alt="Logo" /> Thyme</h4>
                                <h3><strong>{t('login.softwareName')}</strong> {t('login.softwareName1')}</h3>
                                <p>{t('login.softDesc')}</p>
                                <div className="footer">
                                    <ul className="social_link list-unstyled">
                                        <li><a href="#/" title="Youtube"><i className="zmdi zmdi-globe"></i></a></li>
                                        <li><a href="#/" title="LinkedIn"><i className="zmdi zmdi-linkedin"></i></a></li>
                                        <li><a href="#/" title="Facebook"><i className="zmdi zmdi-facebook"></i></a></li>
                                        <li><a href="#/" title="Twitter"><i className="zmdi zmdi-twitter"></i></a></li>
                                        <li><a href="#/" title="Behance"><i className="zmdi zmdi-behance"></i></a></li>
                                        <li><a href="#/" title="dribbble"><i className="zmdi zmdi-dribbble"></i></a></li>
                                    </ul>
                                    <hr />
                                    <p className="copyright font-12">{t('login.copyright')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="card-plain ml-auto">
                                <div className="header">
                                    <h5>{t('login.title')}</h5>
                                </div>
                                <form id='frmLogin' className="form mt-5" onSubmit={submitLogin}>
                                    <div className="form-group mb-1">
                                        <div className="input-group">
                                            <input type="text" className="form-control" name='email' id='email' placeholder={t('login.email')} 
                                                value={formItems.email} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input type="password" className="form-control" name='password' id='password' placeholder={t('login.password')}
                                                value={formItems.password} onChange={handleChange} required />
                                        </div>
                                        <a href="#/" className="link font-13 float-right">{t('login.forgot')}</a>
                                    </div>
                                    <div className="mt-4">&nbsp;
                                        {/* <label className="c_checkbox">
                                            <input type="checkbox" />
                                                <span className="checkmark"></span>
                                                <span className="ml-2">Keep me logged in</span>
                                        </label> */}
                                    </div>
                                </form>
                                <div className="footer mt-3">
                                    <button type='submit' form='frmLogin' className="btn btn-secondary btn-block">{t('login.login')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;